(function (root) {
  'use strict';
  const KEY = 'currenhaus.saved-machines';
  const VERSION = 1;
  const validId = value => typeof value === 'string' && /^\d{1,25}$/.test(value);
  const identity = item => `${item.machineId}:${item.configurationId}`;
  function decode(raw) {
    if (!raw) return { version: VERSION, machines: [], active: null };
    const data = JSON.parse(raw);
    if (data.version !== VERSION || !Array.isArray(data.machines) || data.machines.length > 100) throw new Error('We could not load your saved machine list. Please choose your machine again.');
    const machines = [];
    for (const item of data.machines) {
      if (!item || !validId(item.machineId) || !validId(item.configurationId)) throw new Error('We could not read your saved machine details. Please choose your machine again.');
      const clean = { machineId: item.machineId, configurationId: item.configurationId };
      if (!machines.some(other => identity(other) === identity(clean))) machines.push(clean);
    }
    return { version: VERSION, machines, active: machines.some(item => identity(item) === data.active) ? data.active : null };
  }
  function create(storage) {
    let state = decode(null), notice = '', persistent = true;
    try { state = decode(storage.getItem(KEY)); } catch (error) {
      notice = error instanceof SyntaxError ? 'We could not read your saved machine details. Please choose your machine again.' : error.message;
      if (!notice.includes('machine')) notice = 'Your browser cannot save machines right now. You can still check compatibility during this visit.';
    }
    const copy = () => JSON.parse(JSON.stringify(state));
    function persist() {
      try { storage.setItem(KEY, JSON.stringify(state)); persistent = true; notice = ''; }
      catch (_) { persistent = false; notice = 'This browser could not save your machine list for next time. You can still check compatibility during this visit.'; }
    }
    return {
      get: copy,
      message: () => notice,
      persistent: () => persistent,
      save(machineId, configurationId) {
        if (!validId(machineId) || !validId(configurationId)) throw new Error('Please choose a machine and setup from the list.');
        const item = { machineId, configurationId };
        if (!state.machines.some(other => identity(other) === identity(item))) {
          if (state.machines.length >= 100) throw new Error('Your saved machine list is full. Remove one to make room for another.');
          state.machines.push(item);
        }
        state.active = identity(item); persist(); return copy();
      },
      activate(key) {
        if (!state.machines.some(item => identity(item) === key)) throw new Error('Choose a machine from your saved list.');
        state.active = key; persist(); return copy();
      },
      remove(key) {
        state.machines = state.machines.filter(item => identity(item) !== key);
        if (state.active === key) state.active = null;
        persist(); return copy();
      }
    };
  }
  const api = { create, decode, identity, key: KEY, version: VERSION };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.CurrenhausSavedMachines = api;
})(typeof window !== 'undefined' ? window : globalThis);

